/* Assets.js */

import axios from 'axios';

const URL_CATEGORIES_SET = `https:${process.env.REACT_APP_REMOTE_ASSETS_JSON_URL}`;
const URL_THEME = `https:${process.env.REACT_APP_REMOTE_ASSETS_THEMES_LIST}`;
const URL_STYLES_ONLY_IMAGES = `https:${process.env.REACT_APP_URL_STYLES_ONLY_IMAGES}`;
const URL_STYLE = `https:${process.env.REACT_APP_URL_STYLE}`;
const URL_SONG_LIST = `https://${process.env.REACT_APP_SONG_LIST_URL}`;
const URL_GENRES_LIST = `https://${process.env.REACT_APP_GENRES_LIST_URL}`;
const STYLE_SRC = process.env.REACT_APP_PZ_REMOTE_ASSETS_JSON_URL + 'style/style_{id}.json';
const SONG_URL = process.env.REACT_APP_SONG_URL + 'song_{id}.json';
const URL_BACKGROUNDS = process.env.REACT_APP_BACKGROUNDS;

const api = axios.create();

const Assets = {

  getCategoriesSet: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_CATEGORIES_SET)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCategories: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_THEME)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCatImages: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_STYLES_ONLY_IMAGES)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getStyle: async function (cat) {
    const url = URL_STYLE.replace('{cat}', cat);

    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getSongList: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_SONG_LIST)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getGenresList: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_GENRES_LIST)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getSingleStyle: async function (id) {
    const styleSRC = STYLE_SRC.replace('{id}', id);
    return new Promise((resolve, reject) => {
      api
        .get(styleSRC)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getSingleSong: async function (id) {
    const songSRC = SONG_URL.replace('{id}', id);
    return new Promise((resolve, reject) => {
      api
        .get(songSRC)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getBackgrounds: async function () {
    return new Promise((resolve, reject) => {
      api
        .get(URL_BACKGROUNDS)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default Assets;
